class Main {
    constructor() {
        window.language = document.documentElement.lang;
        window.addEventListener('load', this.ready.bind(this));

        window.csrfParam = document.getElementsByName('csrf-param')[0].getAttribute('content');
        window.csrfToken = document.getElementsByName('csrf-token')[0].getAttribute('content');
    }

    ready() {
        blockingScrollObject.initialize();
        languageObject.initialize();
        riveObject.initialize();
        changelogObject.initialize();
    }

    showList(e) {
        const event = e || window.event;
        let target = event.target;

        while (target !== null) {
            if (target.tagName.toLowerCase() === 'button') {
                target = target.parentElement;
                break;
            }

            target = target.parentElement;
        }

        if (target === null) return;

        target.classList.toggle('_show');
    }

    ajax(url, callback, data) {
        try {
            let x = new (window.XMLHttpRequest || ActiveXObject)("MSXML2.XMLHTTP.3.0");
            let body = ['\r\n'];
            x.open(typeof data !== 'undefined' && data !== null && typeof data === "object" ? "POST" : "GET", url, true);
            x.setRequestHeader("X-Requested-With", "XMLHttpRequest");
            if (data !== null && typeof data === "object") {
                if (typeof data['language'] === 'undefined') {
                    data['language'] = language;
                }

                if (typeof data[csrfParam] === 'undefined') {
                    data[csrfParam] = csrfToken;
                }

                let boundary = String(Math.random()).slice(2);
                let boundaryMiddle = '--' + boundary + '\r\n';
                let boundaryLast = '--' + boundary + '--\r\n'

                let keys = Object.keys(data);
                for (let i = 0, size = keys.length; i < size; i++) {
                    body.push('Content-Disposition: form-data; name="' + keys[i] + '"\r\n\r\n' + data[keys[i]] + '\r\n');
                }

                body = body.join(boundaryMiddle) + boundaryLast;

                x.setRequestHeader('Content-Type', 'multipart/form-data; boundary=' + boundary);
            } else {
                x.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
            }
            x.setRequestHeader('Accept', 'text/html;q=0.9,*/*');
            x.withCredentials = true;
            x.onreadystatechange = function () {
                if (x.readyState !== x.DONE) return;

                if (x.status === 200) {
                    callback && callback(x.responseText, x);
                }
            };
            if (data !== null && typeof data === "object") {
                x.send(body);
            } else {
                x.send();
            }
        } catch (e) {
            window.console && console.log(e);
        }
    }
}

window.main = new Main();
